module.exports = __webpack_public_path__ + "static/media/icon-arrow-red-down.b38b342d.svg";